
<template>
    <div class="autocomplete">
			<input type="text"
        :placeholder="placeHolderText"
        v-model="inputValue"
        :class="[
          classValue,
            {
              'loading-circle' : (inputValue.length > 0),
              'hide-loading-circle': resultItems.length > 0 || resultItems.length == 0 && !autoCompleteProgress,
            }
          ]"
        @input="!autoCompleteProgress ? onKeyUp(inputValue) : '',arrowCounter=0"
        @keyup.down="down"
        @keyup.up="up"
        @keyup.enter="onEnter"
        :maxlength="maxlength"
        />
			<ul class="autocomplete-results" id="autocomplete-results" :style="styleValue" v-if="resultItems.length > 0">
				<li
          class="autocomplete-result"
          v-for="(item, i) in resultItems"
          :key="i"
          @click="onSelected(item.itemList)"
          :class="{ 'is-active': i === arrowCounter }"
          >
					{{ item.itemText }}
				</li>
			</ul>
		</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
    props: {
        placeHolderText: String,
        onKeyUp: Function,
        onSelected: Function,
        resultItems: Array,
        autoCompleteProgress: Boolean,
        keywordSearch: String,
        classValue: String,
        styleValue: String,
        maxlength: Number,
    },
    data() {
      return {
        selectedIndex: null,
        inputValue: this.keywordSearch,
        arrowCounter: 0,
        activedescendant: '',
      }
    },
    methods: {
      setValue(value) {
        this.inputValue = value;
      },
      down () {
        if (this.arrowCounter < (this.resultItems.length - 1)) {
            const container = document.querySelector('.autocomplete-results')
            var total_div = document.getElementById("autocomplete-results").children.length;
            var height = container.scrollHeight;
            var single = (height/total_div);
            var scroll_top = container.scrollTop;
            var scroll_final = scroll_top + single;
            if(this.arrowCounter < (total_div)) {
              container.scrollTop = scroll_final;
            }
            this.arrowCounter = this.arrowCounter + 1;
        }
      },
      up() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
          const container = document.querySelector('.autocomplete-results')
          var total_div = document.getElementById("autocomplete-results").children.length;
          var height = container.scrollHeight;
          var single = (height/total_div);
          var scroll_top = container.scrollTop;
          var scroll_final = scroll_top - single;
          container.scrollTop = scroll_final;
        }
      },
      setActiveDescendent() {
        this.activedescendant = this.getId(this.arrowCounter);
      },
      getId(index) {
        return `result-item-${index}`;
      },
      onEnter() {
        this.search = this.resultItems[this.arrowCounter].itemList;
        this.onSelected(this.search);
      },
    },

}
</script>

<style>
/*********** AUTO COMPLETE ************/
.loading-circle {
    background-image: url(../../assets/throbber-active.gif);
    background-position: 100% center;
    background-color: #ffffff;
    background-repeat: no-repeat;
}

.hide-loading-circle {
    background: none;
    background-image: url(../../assets/throbber-inactive.png);
    background-position: 100% center;
    background-repeat: no-repeat;
    background-color: #ffffff;
}

.form-textinput{
	padding: 0;
}

.autocomplete {
    position: relative;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    margin-top: 0px;
    border: 1px solid;
    height: 120px;
    overflow: auto;
    background-color:#FFFFFF;
    position: absolute;
    z-index: 100;
    width: 100%;
    white-space: nowrap;
    overflow-x: hidden;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 10px;
    cursor: pointer;
}

    .autocomplete-result:hover {
        background-color: #0074B5;
        color: white;
    }
    .is-active {
      background-color: #0074B5;
      color: white;
    }
/*********** END AUTO COMPLETE ************/
</style>



// WEBPACK FOOTER //
// src/components/admin/enterprise_autocomplete.vue